<template>
  <section class="tickets container align-center py-12" id="ticketbox">
      <div class="ticket-header"><v-btn color="success" class="btn-mobile" depressed rounded small @click="backToList()"
        >{{ $t("Back to Tickets") }}
      </v-btn>
          <v-btn
        v-if="!ticket || ticket.request_status != 4"
        color="primary" class="btn-mobile"
        depressed
        rounded
        small
        @click="startReply(true)"
        ><i class="fal fa-reply"></i> {{ $t("Reply") }}
      </v-btn></div>
    <div class="ticket-header">
      <v-btn color="success" class="btn-desktop" depressed rounded small @click="backToList()"
        >{{ $t("Back to Tickets") }}
      </v-btn>
      <div v-if="ticket && ticket.rel_category_label">
        <strong>{{ $t("Category") }}:</strong> {{ ticket.rel_category_label }} -
        {{ ticket.rel_category__rel_parent_category_label }}
      </div>
      <div
        v-if="userProfile == 'MANAGER' && ticket && ticket.rel_project_label"
      >
        <strong>{{ $t("Project") }}:</strong> {{ ticket.rel_project_label }} -
        {{ ticket.rel_section_label }}
      </div>
      <v-btn
        v-if="!ticket || ticket.request_status != 4"
        color="primary" class="btn-desktop"
        depressed
        rounded
        small
        @click="startReply(true)"
        ><i class="fal fa-reply"></i> {{ $t("Reply") }}
      </v-btn>
    </div>

    <div class="ticket-approval" v-if="ticket && ticket.request_type == '2'">
      <div class="ticket-approval-app1">
        <svg
          width="15"
          height="13"
          viewBox="0 0 15 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.2828 0.000880994C11.1713 0.0201837 11.0819 0.0996659 11.0505 0.205263C11.0192 0.311997 11.0517 0.425542 11.1342 0.500482L13.8663 3.17108H0.326526C0.317233 3.17108 0.30794 3.17108 0.298647 3.17108C0.289355 3.17108 0.280062 3.17108 0.270769 3.17108C0.106982 3.18584 -0.0138261 3.32891 0.00127481 3.48901C0.0163757 3.64911 0.162739 3.76719 0.326526 3.75243H13.8663L11.1342 6.42303C11.0459 6.49343 11.0052 6.60584 11.0308 6.71484C11.0563 6.82271 11.1435 6.90787 11.2538 6.93285C11.3653 6.95783 11.4803 6.91809 11.5523 6.83179L14.7956 3.67068L15 3.46176L14.7956 3.25283L11.5523 0.0917176C11.4908 0.0269966 11.4013 -0.00593175 11.3107 0.000880994C11.3014 0.000880994 11.2921 0.000880994 11.2828 0.000880994ZM3.00288 9.53873C2.27223 9.53873 1.65425 10.052 1.51602 10.7287H0.326526C0.317233 10.7287 0.30794 10.7287 0.298647 10.7287C0.289355 10.7287 0.280062 10.7287 0.270769 10.7287C0.106982 10.7434 -0.0138261 10.8865 0.00127481 11.0466C0.0163757 11.2067 0.162739 11.3248 0.326526 11.31H1.51602C1.65425 11.9868 2.27223 12.5 3.00288 12.5C3.73353 12.5 4.35151 11.9868 4.48974 11.31H5.97661C6.11484 11.9868 6.73282 12.5 7.46347 12.5C8.19412 12.5 8.8121 11.9868 8.95033 11.31H10.4372C10.5754 11.9868 11.1934 12.5 11.9241 12.5C12.6547 12.5 13.2727 11.9868 13.4109 11.31H14.6004C14.7073 11.3112 14.8072 11.2567 14.8618 11.1658C14.9152 11.075 14.9152 10.9637 14.8618 10.8729C14.8072 10.7821 14.7073 10.7276 14.6004 10.7287H13.4109C13.2727 10.052 12.6547 9.53873 11.9241 9.53873C11.1934 9.53873 10.5754 10.052 10.4372 10.7287H8.95033C8.8121 10.052 8.19412 9.53873 7.46347 9.53873C6.73282 9.53873 6.11484 10.052 5.97661 10.7287H4.48974C4.35151 10.052 3.73353 9.53873 3.00288 9.53873ZM3.00288 10.1746C3.48611 10.1746 3.86712 10.547 3.86712 11.0194C3.86596 11.0319 3.86596 11.0432 3.86712 11.0557C3.84853 11.5099 3.47333 11.8641 3.00288 11.8641C2.51965 11.8641 2.13864 11.4917 2.13864 11.0194C2.13864 10.547 2.51965 10.1746 3.00288 10.1746ZM7.46347 10.1746C7.93973 10.1746 8.31842 10.5379 8.32771 11.0012C8.32655 11.0194 8.32655 11.0375 8.32771 11.0557C8.30912 11.5099 7.93392 11.8641 7.46347 11.8641C6.98024 11.8641 6.59923 11.4917 6.59923 11.0194C6.59923 10.547 6.98024 10.1746 7.46347 10.1746ZM11.9241 10.1746C12.4073 10.1746 12.7883 10.547 12.7883 11.0194C12.7871 11.0319 12.7871 11.0432 12.7883 11.0557C12.7697 11.5099 12.3945 11.8641 11.9241 11.8641C11.4408 11.8641 11.0598 11.4917 11.0598 11.0194C11.0598 10.547 11.4408 10.1746 11.9241 10.1746Z"
            fill="black"
          />
        </svg>

        <span style="margin-left: 10px">{{ $t("Request Status") }} </span>
      </div>
      <div class="ticket-approval-app2">
        <div class="inline-flex-container">
          <div class="part1">{{ $t("Request Status") }}:</div>
          <div class="part2">
            <b :style="{ color: '#' + ticket.cfd_request_status_color }">{{
              ticket.cfd_request_status_label
            }}</b>
          </div>
        </div>
        <div class="inline-flex-container" v-if="ticket.estimated_start_date">
          <div class="part1">{{ $t("Start and End Date") }}:</div>
          <div class="part2">
            {{ ticket.estimated_start_date | date }} -
            {{ ticket.estimated_delivery_date | date }}
            (
            {{
              difffDates(
                ticket.estimated_start_date,
                ticket.estimated_delivery_date
              )
            }}
            )
          </div>
        </div>
        <div class="inline-flex-container half" v-if="ticket.estimated_effort">
          <div class="part1">{{ $t("Total Effort") }}:</div>
          <div class="part2">
            <b>{{ ticket.estimated_effort | showEffort }}</b> man - {{ticket.estimated_effort>8 ? 'day' : 'hour'}}
          </div>
        </div>
        <div class="inline-flex-container half" v-if="ticket.estimated_effort">
          <div class="part1">{{ $t("Approval Contact") }}:</div>
          <div class="part2">
             {{ticket.approval_contact}}
          </div>
        </div>
        <!-- ---{{ticket}} -->
      </div>
      <div
        class="ticket-approval-app3"
        v-if="ticket && ticket.request_status == 4"
      >
        <a class="approve" @click="startReply(true, 'approve')">{{
          $t("Approval")
        }}</a>
        <a class="revision" @click="startReply(true, 'revision')">{{
          $t("Request Revision")
        }}</a>
        <a class="last-item cancel" @click="startReply(true, 'cancel')">{{
          $t("Cancel Request")
        }}</a>
      </div>
    </div>
    <div class="bg-white shadow p-4">
      <div class="pt-4 pb-4 flex" v-if="ticket">
        <h1 class="ticket-title flex-grow-1">
          #{{ ticket.record_id }} - {{ ticket.subject }}
        </h1>
        <div class="right">
          <i
            :title="ticket.cfd_priority_label"
            :style="{ color: '#' + ticket.cfd_priority_color }"
            :class="'fal ' + ticket.cfd_priority_value"
            class="margin-right-5"
          ></i>
          <span
            class="
              ticket-label
              text-xs
              font-semibold
              inline-block
              py-1
              px-2
              uppercase
              rounded-full
              text-gray-600
              bg-gray-200
              uppercase
              last:mr-0
              mr-1
            "
            >{{ ticket.cfd_message_status_label }}</span
          >
          <span
            class="
              ticket-status
              text-xs
              font-semibold
              inline-block
              py-1
              px-2
              uppercase
              rounded-full
              text-pink-600
              bg-pink-200
              uppercase
              last:mr-0
              mr-1
            "
            >{{ ticket.cfd_case_status_label }}</span
          >
        </div>
      </div>
      <v-expansion-panels multiple v-model="panel">
        <v-expansion-panel v-for="message in messages" :key="message.record_id">
          <v-expansion-panel-header>
            <div class="header-items">
              <div style="width: 46px">
                <v-avatar color="grey lighten-2" :size="36">
                  <span class="white--text headline">{{
                    message.sender_name
                      .split(" ")
                      .reduce((acc, name) => acc + name[0], "")
                  }}</span>
                </v-avatar>
              </div>
              <div>
                {{ message.sender_name }} -
                {{ message.send_date | dateFormat("DD MM YYYY - HH:mm") }}
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="message border-b-2 border-gray-300 pb-4 pt-4">
              <!-- <header class="pb-4 flex">
                <div class="left flex-grow-1 flex align-center">
                  
                  <div class="sender-name text-blue-500 pr-2 pl-2">
                    {{ message.sender_name }}
                  </div>
                  <div class="send-date">
                    {{ message.send_date | dateFormat("DD MM YYYY - HH:mm") }}
                  </div>
                </div>
                <div class="right">
                  <span class="label">
                    {{ message.cfd_sender_label }}
                  </span>
                </div>
              </header> -->
              <article v-html="message.stripped_message"></article>
              <footer class="pt-4" v-if="message.attachments.length">
                <v-container fluid>
                  <v-row dense>
                    <v-col
                      v-for="file in message.attachments"
                      :key="file.file_name"
                      :cols="2"
                    >
                      <v-card>
                        <template v-if="file.isImage">
                          <v-img
                            class="white--text align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            height="140px"
                          >
                            <img
                              :src="
                                attachmentPath +
                                '?messageId=' +
                                message.record_id +
                                '&t=' +
                                token +
                                '&fileId=' +
                                file.uid
                              "
                              :class="`viewer-${file.uid}`"
                              style="
                                min-width: 100%;
                                opacity: 0.5;
                                min-height: 100%;
                              "
                              v-viewer
                            />
                          </v-img>
                        </template>
                        <template v-else>
                          <v-img
                            class="white--text align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            height="140px"
                          >
                            <i
                              :class="getFileIcon(file, ' icon-file fad', 'md')"
                            ></i>
                            <v-card-title v-text="file.title"></v-card-title>
                          </v-img>
                        </template>

                        <v-card-actions>
                          {{ file.file_name | shortenFileName }}
                          <v-spacer></v-spacer>

                          <a
                            v-if="file.isImage"
                            @click="openModal(file, message.record_id)"
                            target="_blank"
                            icon
                          >
                            <v-icon>mdi-eye</v-icon>
                          </a>
                          <a
                            :href="
                              attachmentPath +
                              '?download=1&messageId=' +
                              message.record_id +
                              '&t=' +
                              token +
                              '&fileId=' +
                              file.uid +
                              '&fn=' +
                              file.file_name
                            "
                            target="_blank"
                            icon
                          >
                            <v-icon>mdi-download</v-icon>
                          </a>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </footer>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <footer class="pt-4">
        <div class="pt-4" v-show="!isReply">
          <v-btn
            color="primary"
            depressed
            rounded
            large
            @click="startReply(true)"
            ><i class="fal fa-reply"></i> {{ $t("Reply") }}
          </v-btn>
        </div>

        <div v-show="isReply">
          <redactor
            v-model="reply"
            :config="configOptions"
            @keyup.enter="sendMessage"
          ></redactor>
          <a @click="showFile = true" class="add-file-link">
            {{ $t("+ Attach files to this message") }}
          </a>
          <template v-if="showFile">
            <VueFileAgent
              ref="vueFileAgent"
              :theme="'grid'"
              :multiple="true"
              :deletable="true"
              :meta="true"
              :accept="'image/*,.docx,.doc,.xls,.xlsx,.pdf,.zip'"
              :maxSize="'10MB'"
              :maxFiles="14"
              :helpText="'Choose images or files'"
              :errorText="{
                type: 'Invalid file type. Only images or zip Allowed',
                size: 'Files should not exceed 10MB in size',
              }"
              v-model="attachments"
              @select="filesSelected($event)"
              @beforedelete="onBeforeDelete($event)"
            ></VueFileAgent>
          </template>
          <div class="pt-4">
            <v-btn color="primary" rounded large @click.prevent="sendReply"
              >{{
                revisionType
                  ? revisionType == "revision"
                    ? $t("Submit Revision Request")
                    : revisionType == "approve"
                    ? $t("Approve Request")
                    : revisionType == "cancel"
                    ? $t("Cancel Request")
                    : $t("Send Undefined")
                  : $t("Send")
              }}
            </v-btn>
            <v-btn
              color="danger"
              class="ml-5"
              depressed
              rounded
              large
              @click="startReply(false, '')"
              >{{ $t("Cancel") }}
            </v-btn>
          </div>
        </div>
      </footer>
    </div>
    <div class="goTop" @click="goTop()">
      <i class="fal fa-chevron-up"></i>
    </div>
  </section>
</template>

<script>
import { MessageProxy } from "@/proxies/MessageProxy";
import { CreateMessageProxy } from "@/proxies/CreateMessageProxy";
import { ThreadProxy } from "@/proxies/ThreadProxy";
import { ThreadStatusUpdateProxy } from "@/proxies/ThreadStatusUpdateProxy";
import fileMixin from "@/mixins/files";
import { mapState, mapGetters } from "vuex";
import { UploadFileProxy } from "@/proxies/UploadFileProxy";
import SvgIcon from "@/components/common/kvSvgIcon.vue";
import Vue from "vue";
import moment from "moment";
import VueFileAgent from "vue-file-agent";
import VueFileAgentStyles from "vue-file-agent/dist/vue-file-agent.css";
Vue.use(VueFileAgent);

export default {
  name: "TicketDetail",
  mixins: [fileMixin],
  components: {
    SvgIcon,
  },
  props: {
    id: { required: true },
  },
  data() {
    return {
      selectedImage: { title: "", src: null },
      revisionType: "",
      ticket: null,
      sending: false,
      showFile: false,
      messages: [],
      attachments: [],
      isReply: false,
      reply: "",
      panel: [0],
      configOptions: {
        plugins: ["clips", "fontsize", "fullscreen", "table", "inlinestyle"],
        buttonsHide: ["html", "align", "strikethrough"],
        buttons: [
          "redo",
          "undo",
          "format",
          "bold",
          "italic",
          "lists",
          "image",
          "file",
          "link",
          "clips",
        ],
        minHeight: "170px",
        editor: { focus: false },
      },
    };
  },
  computed: {
    ...mapState("account", ["token"]),
    ...mapGetters("account", ["userProfile"]),
  },
  created() {
    this.getMessages();
    this.getTicket();
  },
  methods: {
    difffDates(d1, d2) {
      return moment(d2).diff(moment(d1), "days");
    },
    backToList() {
      if (this.ticket.request_type == "2") {
        this.$router.push("/requests");
      } else {
        this.$router.push("/tickets");
      }
    },
    approveOffer() {
      this.revisionType = "approve";
      this.isReply = status;
      setTimeout(() => {
        let element = document.getElementById("ticketbox");
        element.scrollIntoView({ behavior: "smooth", block: "end" });
      }, 300);

      // this.$confirm("Do you really want to approve  this request?").then(
      //   (res) => {
      //     if (res) {
      //       new ThreadStatusUpdateProxy()
      //         .create({
      //           item: {
      //             requestStatus: 5,
      //             threadId: this.ticket.record_id,
      //           },
      //         })
      //         .then(() => {
      //           this.$emit("updated");
      //         });
      //     }
      //   }
      // );
    },
    cancelRequest() {
      this.$confirm("Do you really want to cancel this request?").then(
        (res) => {
          if (res) {
            new ThreadProxy()
              .update({
                id: this.ticket.record_id,
                item: {
                  request_status: 8,
                },
              })
              .then(() => {
                this.$emit("updated");
              });
          }
        }
      );
    },
    sendMessage(event) {
      if (event.shiftKey === true && event.key === "Enter") {
        this.sendReply();
      }
    },
    goTop() {
      let element = document.getElementById("ticketbox");
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    filesSelected: function (fileRecordsNewlySelected) {},
    onBeforeDelete: function (fileRecordsNewlySelected) {
      var i = this.attachments.indexOf(fileRecordsNewlySelected);
      this.attachments.splice(i, 1);
    },
    uploadFile(id) {
      this.attachments.forEach((k) => {
        let item = new FormData();
        let attachment = k;
        item.append("file", attachment.file, attachment.file.name);
        item.append("messageId", id);

        new UploadFileProxy()
          .create({
            item,
            messageId: id,
          })
          .then(() => {
            this.isReply = false;
            this.reply = "";
            this.getMessages();
          });
      });
    },
    startReply(status, revisionType = false) {
      this.revisionType = revisionType;
      this.isReply = status;
      setTimeout(() => {
        let element = document.getElementById("ticketbox");
        element.scrollIntoView({ behavior: "smooth", block: "end" });
      }, 300);
    },
    openModal(file, id) {
      if (file.isImage) this.imageModal = true;

      let r =
        this.attachmentPath +
        "?messageId=" +
        id +
        "&t=" +
        this.token +
        "&fileId=" +
        file.uid;
      console.log("viewer", file.uid);
      const viewer = this.$el.querySelector(`.viewer-${file.uid}`).$viewer;
      viewer.show();
    },

    getTicket() {
      new ThreadProxy({
        parameters: {
          threadId: this.id,
        },
      })
        .all()
        .then((response) => {
          this.ticket = response.data;  
        });
    },

    getMessages() {
      new MessageProxy({
        parameters: {
          threadId: this.id,
        },
      })
        .all()
        .then((response) => {
          let messages = response.data;
          messages = messages.map((k) => {
            let attachments = k.attachments.map((a) => {
              a.stripped_message = a.stripped_message
                ? a.stripped_message.replaceAll("<img ", '<img loading="lazy"')
                : "";

              return { ...a, isImage: this.isImageType(a) };
            });
            return { ...k, attachments };
          });
          this.messages = messages;

          setTimeout(() => {
            let element = document.getElementById("ticketbox");
            element.scrollIntoView({ behavior: "smooth", block: "start" });
            this.panel = [0];
          }, 500);
        });
    },
    sendReply() {
      let reply = this.reply == "<p><br></p>" ? "" : this.reply;
      let requestStatus =
        this.revisionType == "approve"
          ? 5
          : this.revisionType == "cancel"
          ? 8
          : this.revisionType == "revision"
          ? 3
          : "";
      if (reply == "") {
        reply =
          requestStatus == 5
            ? "Request Approved"
            : requestStatus == 8
            ? "Request Cancelled"
            : "";
      }
      if (reply) {
        new CreateMessageProxy()
          .create({
            item: {
              threadId: this.id,
              message: reply,
            },
          })
          .then((response) => {
            this.revisionType = "";
            if (requestStatus) {
              new ThreadStatusUpdateProxy()
                .create({
                  item: {
                    requestStatus,
                    threadId: this.ticket.record_id,
                  },
                })
                .then(() => {
                  this.$emit("updated");
                  this.getTicket();
                });
            }

            if (this.attachments && this.attachments[0]) {
              this.uploadFile(response.message_id);
            } else {
              // this.$router.push({ name: "tickets" });
              this.isReply = false;
              this.reply = "";
              this.getMessages();
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none !important;
}
.goTop {
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: fixed;
  right: 10px;
  bottom: 10px;
  text-align: center;
  padding: 4px 0px;

  border-radius: 50%;
  background: rgba(59, 130, 246, 0.5);
  transition: 1s all;
  &:hover {
    transition: 1s all;
    background: rgba(59, 130, 246, 1);
  }
  i {
    padding: 5px;
    color: #fff;
    font-size: 22px;
  }
}
.ticket-header {
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  margin-bottom: 10px;
  div {
    padding: 5px;
  }
}
.ticket-title {
  font-weight: 600;
  font-size: 18px;
  color: var(--dark-gray);
}
.icon-file {
  font-size: 120px;
}
.v-expansion-panel::before {
  box-shadow: 0px 1px 0px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%),
    0px 1px 0px 0px rgb(144 144 144 / 12%) !important;
}
.v-expansion-panel-content__wrap {
  font-size: 14px;
  p {
    margin-bottom: 0;
    font-size: 14px;
  }
}
.v-image {
  text-align: center;
}
.margin-right-5 {
  margin-right: 10px;
  padding-top: 4px;
}
.add-file-link {
  font-size: 15px;
  margin: 6px 0;
}
.add-file-link {
  font-size: 15px;
}
.file-preview {
  img,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: inline-block !important;
  }
}
.v-card__actions {
  font-size: 12px;
}
.tickets img {
  display: inline-block;
}
.header-items {
  display: flex;
  align-items: baseline;
}
.ticket-approval {
  box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1),
    0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 0px 0px 1px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  width: 100%;
  height: 97px;
  line-height: 2;
  background: #fff;
  margin: 15px 0px;
  padding: 0px;
  display: inline-flex;
  .ticket-approval-app1 {
    margin-left: 10px;
    width: 210px;
    padding: 10px;
    font-size: 15px;
    display: inline-flex;
    svg {
      margin-top: 5px;
    }
  }
  .ticket-approval-app2 {
    width: 100%;
    font-size: 14px;
    line-height: 2;
    padding: 10px;

    display: block;
    .inline-flex-container {
      display: inline-flex;
      width: 100%;
      &.half{
        
        width: 50%;
      }
    }
    .part1 {
      width: 190px;
      text-align: right;
      margin-right: 10px;
      color: #91a0b4;
      font-weight: 500;
    }
    .part2 {
      width: 100%;
      text-align: left;
    }
  }
  .ticket-approval-app3 {
    display: block;
    width: 200px;
    a {
      width: 100%;
      display: block;
      color: #374151;
      font-size: 12px;
      padding: 5.3px 2px;
      font-weight: 500;
      line-height: 1.8;
      border-bottom: 1px solid #e5e7eb;
      border-left: 1px solid #e5e7eb;
      text-align: center;
      &:hover {
        color: #546b91;
      }
    }
    a.last-item {
      border-bottom: 0;
    }
    a.approve {
      color: #4caf50;
    }
    a.revision {
      color: #e6a84b;
    }
    a.cancel {
      color: #dd2777;
    }
  }
}
</style>
